import { Toggle } from '@osmosis/nextjs-components/Toggle';
export * from '@osmosis/nextjs-components/Toggle';

export default Toggle;
